import { render, staticRenderFns } from "./TrancheOutstandingPayments.vue?vue&type=template&id=2ce93b9c&"
import script from "./TrancheOutstandingPayments.vue?vue&type=script&lang=js&"
export * from "./TrancheOutstandingPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports